'use strict';

import angular from 'angular';

import saJoin from './join.component';
import saJoinForm from './join_form.component';
import saJoinOptionButton from './join_option_button.component';
import saJoinOptions from './join_options.component';
import saSignInForm from './sign_in_form.component';
import saSignUpForm from './sign_up_form.component';
import joinForm from './join_form.service';

import 'nls!./join.json';

export default angular
  .module('join', [])
  .directive('saJoin', saJoin)
  .directive('saJoinForm', saJoinForm)
  .directive('saJoinOptionButton', saJoinOptionButton)
  .directive('saJoinOptions', saJoinOptions)
  .directive('saSignInForm', saSignInForm)
  .directive('saSignUpForm', saSignUpForm)
  .factory('joinForm', joinForm)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/join/index.js